
















import { Vue, Component } from "vue-property-decorator";
import EnrollmentOrderForm from "@/components/enrollment/EnrollmentOrderForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, EnrollmentOrderForm }
})
export default class EnrollmentOrderNew extends Vue {
  get breadcrumbs() {
    return [
      {
        to: { name: "enrollmentList" },
        label: this.$tc(this.$translate.OrdersOfEnrollment)
      },
      {
        label: this.$tc(this.$translate.Create)
      }
    ];
  }
}
